<template>
  <div>
    <div class="d-inline-block px-1 border border-secondary" style="font-family:monospace; font-size: 1.75rem;" @click.stop="onCopy">
      <span v-if="scramble && (coupon.is_cancelled || coupon.is_expired) && !coupon.is_redeemed && !coupon.do_not_reveal" class="text-muted" style="text-decoration: line-through;">
        xxxxxxx
      </span>
      <span v-if="scramble && !coupon.is_cancelled && !coupon.is_expired && coupon.purchased_not_paid && !coupon.is_redeemed && !coupon.do_not_reveal" class="text-muted" :title="trans('coupon_revealed_after_payment')" v-b-tooltip.hover.right>
        xxxxxxx
      </span>
      <span v-if="(coupon.is_cancelled || coupon.is_expired) && !coupon.purchased_not_paid && !coupon.is_redeemed && !coupon.do_not_reveal && !scramble" class="text-muted">
        {{ coupon.code }}
      </span>
      <strong v-if="!coupon.is_cancelled && !coupon.is_expired && (!coupon.purchased_not_paid && !coupon.is_redeemed && !coupon.do_not_reveal || !scramble && (!coupon.is_redeemed || coupon.purchased_not_paid) && !coupon.do_not_reveal)" style="cursor: pointer;" :title="trans('copy_to_clipboard')" v-b-tooltip.hover.right>
        {{ coupon.code }}
      </strong>
      <span v-if="coupon.is_redeemed && !coupon.do_not_reveal" class="text-muted" style="text-decoration: line-through;">
        {{ (coupon.is_cancelled || !coupon.purchased_not_paid) && scramble ? 'xxxxxxx' : coupon.code }}
      </span>
      <span v-if="coupon.do_not_reveal" class="text-muted">
        xxxxxxx
      </span>
    </div>
    <sup v-if="!coupon.is_cancelled && coupon.purchased_not_paid">
      <b-badge variant="danger">{{ trans('not_paid') }}</b-badge>
    </sup>
    <sup v-if="coupon.is_cancelled">
      <b-badge variant="danger">{{ trans('cancelled') }}</b-badge>
    </sup>
    <sup v-if="coupon.is_expired">
      <b-badge variant="danger">{{ trans('expired') }}</b-badge>
    </sup>
    <sup v-if="coupon.is_redeemed">
      <b-badge variant="danger">{{ trans('redeemed') }}</b-badge>
    </sup>
  </div>
</template>

<script>
  export default {
    props: {
      coupon: Object,
      scramble: { // scramble if not paid or cancelled or not obtained
        type: Boolean,
        default: true,
      },
    },
    data() {
      return {
        trans: trans,
      }
    },
    methods: {
      onCopy() {
        if (this.coupon.purchased_not_paid ||
            this.coupon.is_redeemed ||
            this.coupon.is_cancelled ||
            this.coupon.is_expired ||
            this.coupon.do_not_reveal)
          return
        this.$copyText(this.coupon.code, this.$el).then(() => {
          this.$bvToast.toast(this.coupon.code, {
            title: trans('copied_to_clipboard'),
            autoHideDelay: 3000,
            variant: 'success',
            solid: true,
          })
        })
      },
    },
  }
</script>